import moment from "moment"

export function hearderRebellion(rebellionJson,app){
  rebellionJson = JSON.parse(rebellionJson)

  let strContent = ""
  let Str1 = ""
  let Str2 = ""
  //繰返しあり・なし[0:なし;1:月;2:週;3:日;]
  let repeatTypeCode = rebellionJson.repeatType
  //指定区分 [1：毎;2：カスタマイズ;]
  let intervalTypeCode = rebellionJson.intervalType
  //間隔値
  let intervalValueCode = rebellionJson.intervalValue
  //終日フラグ [true:終日ON;false:終日OFF;]
  let strContentCode = rebellionJson.wholeDayFlg

  let repeatItems = rebellionJson.repeatItems
  let repeatItem = null
  if(repeatItems!=[] &&
    repeatItems!=undefined &&
    repeatItems!=null){
      repeatItem = repeatItems[0]
  }
  //終了日
  let endDate = rebellionJson.endDate

  if(!strContentCode){
    if("0" == repeatTypeCode){
      Str1 = app.$t('繰り返しなし')
    }else {

      if("1" == intervalTypeCode){
        Str1 = app.$t('繰り返し')

        if(repeatItems!=null ||
          repeatItems!=undefined ||
          repeatItems!=""){
            if("1" == repeatTypeCode){
              if (repeatItems.length  == 2) {
                if (repeatItems[0] == -1) {
                  Str2 = moment(endDate).format("YYYY年M月D日") + "毎月の最終" + weekCodeOfValue(repeatItems[1]) + "曜日"
                } else {
                  Str2 = moment(endDate).format("YYYY年M月D日") + "毎月の第" + repeatItems[0] + weekCodeOfValue(repeatItems[1]) + "曜日"
                }
              } else {
                Str2 = moment(endDate).format("YYYY年M月D日") + "毎月の"+repeatItem+"日"
              }
            }else if("2" == repeatTypeCode){
              let week = codeOfValue(repeatItems)
              Str2 = moment(endDate).format("YYYY年M月D日") + "まで、毎週の" + week
            }else if("3" == repeatTypeCode){
              Str2 = moment(endDate).format("YYYY年M月D日") + "まで、毎日"
            }
        }
      }else if("2" == intervalTypeCode){
        Str1 = app.$t('カスタマイズ')

        if(intervalValueCode!=null ||
            intervalValueCode!=undefined ||
            intervalValueCode!=""){

            if("1" == repeatTypeCode){
              if (repeatItems.length == 2) {
                if (repeatItems[0] == -1) {
                  Str2 = moment(endDate).format("YYYY年M月D日") + " " + intervalValueCode + "ヶ月ごと 最終" + weekCodeOfValue(repeatItems[1]) + "曜日"
                } else {
                  Str2 = moment(endDate).format("YYYY年M月D日") + " " + intervalValueCode + "ヶ月ごと 毎月第" + repeatItems[0] + weekCodeOfValue(repeatItems[1]) + "曜日"
                }
              } else {
                Str2 = moment(endDate).format("YYYY年M月D日") + " " + intervalValueCode+"ヶ月ごと 毎月"+repeatItem+"日"
              }
            }else if("2" == repeatTypeCode){
              let week = codeOfValue(repeatItems)
              Str2 = moment(endDate).format("YYYY年M月D日") +intervalValueCode+"週ごと 毎週"+week
            }else if("3" == repeatTypeCode){
              Str2 = moment(endDate).format("YYYY年M月D日") +intervalValueCode+"日ごと"
            }

        }
      }
    }
  }

  strContent = Str1 + Str2

  return strContent
}

function codeOfValue (weekList) {
  let loanDay = ""
  for(let week of weekList){
    if("1" == week){
      loanDay = loanDay + "月、"
    }else if("2" == week) {
      loanDay = loanDay + "火、"
    }else if("3" == week) {
      loanDay = loanDay + "水、"
    }else if("4" == week) {
      loanDay = loanDay + "木、"
    }else if("5" == week) {
      loanDay = loanDay + "金、"
    }else if("6" == week) {
      loanDay = loanDay + "土、"
    }else if("7" == week) {
      loanDay = loanDay + "日、"
    }
  }
  loanDay = loanDay.substring(0, loanDay.length - 1)
  return loanDay
}

function weekCodeOfValue (value){
  let loanDay = ""
  if("1" == value){
    loanDay = "月"
  }else if("2" == value) {
    loanDay = "火"
  }else if("3" == value) {
    loanDay = "水"
  }else if("4" == value) {
    loanDay = "木"
  }else if("5" == value) {
    loanDay = "金"
  }else if("6" == value) {
    loanDay = "土"
  }else if("0" == value) {
    loanDay = "日"
  }
  return loanDay
}
